function DistanceMatrixApi() {
  this.byService = function byService(LatOrigin, LngOrigin, LatDest, LngDest) {
    return new Promise(function(resolve, reject) {
      var origin = new google.maps.LatLng(LatOrigin, LngOrigin);
      var destination = new google.maps.LatLng(LatDest, LngDest);
      var service = new google.maps.DistanceMatrixService();

      service.getDistanceMatrix(
        {
          origins: [origin],
          destinations: [destination],
          travelMode: "DRIVING",
          unitSystem: google.maps.UnitSystem.metric
        },
        function(response, status) {
          if (status == "OK") {
            resolve(response.rows[0]);
          } else {
            reject(status);
          }
        }
      );
    });
  };
  this.byAddress = function byAddress(storeAddress, distinationAddress) {
    return new Promise(function(resolve, reject) {
      var service = new google.maps.DistanceMatrixService();

      service.getDistanceMatrix(
        {
          origins: [storeAddress],
          destinations: [distinationAddress],
          travelMode: "DRIVING",
          unitSystem: google.maps.UnitSystem.metric
        },
        function(response, status) {
          if (status == "OK") {
            resolve(response.rows[0]);
          } else {
            reject(status);
          }
        }
      );
    });
  };

  this.buildAddress = function buildAddress(
    Address,
    Suburb,
    State,
    Postcode,
    Country
  ) {
    var adrs =
      Address +
      ", " +
      (Suburb ? Suburb : "") +
      " " +
      (State ? State : "") +
      " " +
      (Postcode ? Postcode : "") +
      ", " +
      (Country ? Country : "");
    return adrs;
  };
}

export const distanceMatrixApi = new DistanceMatrixApi();
